




















































import * as Vue from '@vue/composition-api'
import DocListItem from '@/ts/if/DocListItem'

interface Props {
  list: DocListItem[],
  newable?: boolean
}

export default Vue.createComponent({
  name: 'DocsList',
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    newable: {
      type: Boolean,
      default: false
    }
  },
  setup (props: Props, ctx) {
    const onItemClick = (item: DocListItem) => {
      ctx.emit('select', item.id)
    }
    const onNewClick = () => {
      ctx.emit('new')
    }
    return {
      onItemClick,
      onNewClick
    }
  }
})
